import Button from '../../../button/v2/button';
import { VStack } from '../../../layouts/stack.layout';
import SelectFormGroup from '../../inputs/select.formGroup';
import TextFormGroup from '../../inputs/text.formGroup';

export default function AccountDetails({ username }: { username: string }) {
  return (
    <VStack align="center" extensions="w-full" gap="base">
      <VStack
        align="center"
        extensions="justify-center w-[90px] h-[90px] bg-[#2E2E2E] rounded-full"
      >
        <Button size="lg" color="base-200" withButtonStyle asIcon="image" />
      </VStack>

      <TextFormGroup name="username" label="username" type="text" />
      <TextFormGroup
        placeholder={username}
        name="displayName"
        label="display name"
        type="text"
      />
      <SelectFormGroup name="accountType" label="account type">
        <option value="fan">Fan</option>
        <option value="artist">Artist</option>
      </SelectFormGroup>
    </VStack>
  );
}
